export const advantageListItemLabels = [
  "Cost savings",
  "Enhanced productivity",
  "Improved safety",
  "Regulatory compliance",
  "Asset protection"
];